<template>
    <div element-loading-spinner="qc-spinner" :loading="loadingCountryData" v-loading="loadingCountryData">
        <canvas id="countryStatsGraph"></canvas>
    </div>
</template>
    
<script>
import Chart from "chart.js";
import { mapGetters, mapState } from "vuex";
import { utils, writeFile } from 'xlsx'
export default {
    name: "country-stats-graph",
    components: {
        Chart,
    },
    data() {
        return {
            loadingCountryData: false,
            countryData: null,
            counter: 5,
            chartName: "",
            sidebarStore: false,
            chart: "",
            chartOptions: {
                responsive: true,
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: true,
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            beginAtZero: true,
                            precision: 0,
                            suggestedMax: 5,
                        },
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)",
                        },
                    }],
                    // yAxes: [{
                    //     gridLines: {
                    //         color: "rgba(0, 0, 0, 0)",
                    //     }
                    // }]
                }
            },
            chartData: {
                labels: [],
                datasets: [
                    {
                        label: 'Number of Verifications',
                        backgroundColor:
                            'rgb(60, 165, 170, 0.2)',
                        borderColor:
                            'rgb(60, 165, 170)',
                        borderWidth: 1,
                        data: []
                    }
                ]
            },
        };
    },
    async mounted() {
        this.$store.state.countryStatsChartName = "Top 5"
        this.chartName = await this.$store.state.countryStatsChartName
        this.setCountryData()
    },
    beforeDestroy() {
        this.$store.state.countryStatsChartName = ""
    },
    methods: {
        downloadData() {
            let downloadData = {
                country: [],
                volume: [],
            }
            for (let i = 0; i < this.chartData.datasets[0].data.length; i++) {
                downloadData.country.push(this.chartData.labels[i])
                downloadData.volume.push(this.chartData.datasets[0].data[i])
            }
            const data = downloadData.country.map((country, i) => ({
                Country: country,
                "Volume": downloadData.volume[i]
            }));
            const worksheet = utils.json_to_sheet(data);
            const workbook = utils.book_new()
            utils.book_append_sheet(workbook, worksheet, "Country Data")
            writeFile(workbook, "Country_Data.xlsx")
        },
        async setCountryData() {
            this.loadingCountryData = true
            if(this.chartName != undefined) {
                this.counter = this.chartName.slice(4)
            }
            await this.$api.getCountryData(this.counter, 12)
                .then(response => {
                    this.countryData = response.data
                    this.chartData.labels = []
                    this.chartData.datasets[0].data = []
                    for (let i = 0; i < this.countryData.length; i++) {
                        this.chartData.labels.push(this.countryData[i].countryName)
                        this.chartData.datasets[0].data.push(this.countryData[i].counter)
                    }
                    // BELOW TO ALPHABETISE THE GRAPH
                    // this.sortChartData()
                    if (this.chart != "") {
                        this.loadingRevenueData = false
                        this.chart.update()
                    } else {
                        this.chartConstructor();
                    }
                    this.loadingCountryData = false;
                }).catch(error => {
                    console.log("ERROR", error)
                })
        },
        chartConstructor() {
            const chartElement = document.getElementById("countryStatsGraph");
            this.chart = new Chart(chartElement, { 
                type: "horizontalBar",
                data: this.chartData,
                options: this.chartOptions
            })
            this.loadingCountryData = false
        },
        // BELOW USED TO ALPHABETISE CHART INFO
        sortChartData() {
            let countries = this.chartData.labels.slice()
            let values = this.chartData.datasets[0].data.slice()
            let countryData = []
            for (let i = 0; i < countries.length; i++) {
                countryData.push({
                    country: countries[i],
                    value: values[i]
                })
            }
            countryData.sort((a, b) => a.country.localeCompare(b.country));
            let sortedCountries = []
            let sortedValues = []
            for (let data of countryData) {
                sortedCountries.push(data.country)
                sortedValues.push(data.value)
            }
            this.chartData.labels = sortedCountries
            this.chartData.datasets[0].data = sortedValues
        },
    },
    computed: {
        ...mapState(["countryStatsChartName", "downloadCountrySheet"]),
        ...mapGetters({
            newCountryStatsChart: "getCountryStatsChartName",
            newDownloadCountrySheet: "getDownloadCountrySheet"
        }),
    },
    watch: {
        newCountryStatsChart: async function (val) {
            this.chartName = val
            this.setCountryData()
        },
        newDownloadCountrySheet: function (val) {
            if(val == true) {
                this.downloadData()
            }
            this.$store.state.downloadCountrySheet = false;
        }
    },
}

</script>